import React, { useState, useEffect } from 'react'
import { Combo } from 'components'
import { fetchUrl } from 'modules/util/functions'

const RotacionSincronicaCombo = (props) => {
	const [items, setItems] = useState([]);

	useEffect(() => {
		fetchUrl("/query/getRotacionesSincronicas", "get", {}, {
			success: (r) => {
				let items = r.data.rotacionesSincronicas.map(x => ({
					value: x.idRotacionSincronica,
					label: x.nombre
				}));

				if (props.exclusions)
					items = items.filter(x => !props.exclusions.includes(x.value.toString()));

				setItems(items);
			}
		}, { block: false });
	}, [props.exclusions]);

	return (
		<Combo
			{...props}
			items={items} />
	)
}

export default RotacionSincronicaCombo;

RotacionSincronicaCombo.defaultProps = {
	formControl: true,
	formManaged: false
};